<template>
    <div class="audioPlayer">
        <div class="audioTitle">{{title}}</div>
        <div class="audioCtrl">
            <div class="audio-btn">
                <span @click="audioState" :class="['audioBtn', play ? 'pauseBtn' : 'playBtn']"></span>
            </div>
            <div class="bar">
                <div class="progressbar" @click="playMusic" ref="runfatbar">
                    <div class="greenbar" ref="runbar">
                        <span class="yuan" draggable="true"></span>
                    </div>
                </div>
                <div class="playTime">
                    <div class="time-text">{{cTime}}</div>
                    <div class="right-time time-text">{{dTime}}</div>
                </div>
            </div>
            <div class="audio-btn">
                <span @click="audioMute" :class="['audioBtn', mute ? 'muteBtn' : 'voiceBtn']"></span>
            </div>
        </div>
        <audio ref="player" id="player" :src="audioUrl"></audio>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
    name: 'AudioPlayerComponent',
    data () {
        return {
            firstPlay: true,
            cTime: '00:00', // 已播放时间
            dTime: '00:00', // 总播放时间
            play: false, // 播放暂停按钮
            mute: false,
        }
    },
    props: ['audioUrl', 'title'],
    mounted () {
        const music = this.$refs.player;  // 音频所在对象
        const musicBar = this.$refs.runbar;  // 颜色进度条所在对象
        const musicWidth = this.$refs.runfatbar.offsetWidth; // 底部进度条总宽
        const leftDistance = this.$refs.runfatbar.offsetLeft;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            wx.config({
                debug: false,
                appId: '',
                timestamp: 1,
                nonceStr: '',
                signature: '',
                jsApiList: []
            });
            wx.ready(function () {
                document.getElementById('player').play();
                document.getElementById('player').pause();
            });   
        } else {
            music.load();
        }
        // 获得音频加载完成可播放时的处理
        music.addEventListener('canplay', () => {
            const musicTime = music.duration;// 获得音频时长
            const branch = Math.floor(musicTime / 60); // 计算音频分钟
            const second = Math.floor(musicTime % 60); // 计算音频秒
            if (branch < 10 && second < 10) { // 四种情况判断音频总时间
                this.dTime = `0${branch}:0${second}`;
            } else if (branch < 10) {
                this.dTime = `0${branch}:${second}`;
            } else if (second < 10) {
                this.dTime = `${branch}:0${second}`;
            } else {
                this.dTime = `${branch}:${second}`;
            }
        });

        // 获得音频正在播放时的处理
        music.addEventListener('timeupdate', () => {
            const musicTime = music.duration // 获得音频时长
            const stopTime = music.currentTime // 获得已播放的音频时长
            // console.log(stopTime, musicTime);
            if (stopTime < musicTime) {
                musicBar.style.width = `${(stopTime / musicTime) * 100}%`; // 计算进度条所在比例宽度
                const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
                const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
                if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
                    this.cTime = `0${branch}:0${second}`
                } else if (branch < 10) {
                    this.cTime = `0${branch}:${second}`
                } else if (second < 10) {
                    this.cTime = `${branch}:0${second}`
                } else {
                    this.cTime = `${branch}:${second}`
                }
            } else {
                musicBar.style.width = '100%';
                this.cTime = this.dTime;
                this.play = false;
            }
        });
        // 监听颜色进度条是否触摸拖动
        musicBar.addEventListener('touchmove', (event) => {
            if (this.firstPlay) {
                return;
            }
            const events = event.targetTouches[0].pageX - leftDistance; // 获得触摸拖动的距离
            musicBar.style.width = events > musicWidth ? '100%' : `${(events / musicWidth) * 100}%`; // 计算进度条所在比例宽度
            music.pause(); // 触摸拖动时停止播放
        });
        // 监听颜色进度条是否触摸拖动结束
        musicBar.addEventListener('touchend', () => {
            if (this.firstPlay) {
                return;
            }
            const touwidth = (musicBar.offsetWidth / musicWidth); // 计算进度条所在比例
            if (touwidth > 1) {
                try {
                    music.currentTime = music.duration;
                    music.pause();
                    this.play = false;
                } catch {
                    // music.pause();
                }
            } else {
                try {
                    music.currentTime = music.duration * touwidth;// 通过所在比例赋值给音频应在的播放时间
                    music.play(); // 根据播放时间开始播放
                    this.play = true; // 更改播放暂停按钮为播放
                } catch {
                    // music.play();
                    console.log('catch');
                }
            }
        });
    },
    methods: {
        // 点击进度条事件
        playMusic (e) {
            this.firstPlay = false;
            const music = this.$refs.player // 音频所在对象
            const barWidth = e.offsetX / this.$refs.runfatbar.offsetWidth // 计算点击位置相对父元素总宽的比例
            this.$refs.runbar.style.width = `${barWidth * 100}%` // 进度条应所在的比例总宽
            music.currentTime = music.duration * barWidth // 计算点击时应播放所在的时间
            music.play() // 播放音频
            this.play = true // 更改播放暂停按钮为播放
        },
        // 点击播放暂停按钮时间
        audioState () {
            this.firstPlay = false;
            this.play = !this.play; // 更改播放暂停按钮状态
            const music = this.$refs.player; // 音频所在对象
            if (this.play) {
                music.play() // 播放音乐
            } else {
                music.pause() // 暂停音乐
            }
        },
        audioMute () {
            this.firstPlay = false;
            this.mute = !this.mute;
            const music = this.$refs.player;
            music.muted = this.mute;
        }
    }
}
</script>


<style lang="scss" scoped>
.audioPlayer {
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 420px;
    padding-bottom: rem(24px);
    border-top-left-radius: rem(24px);
    border-top-right-radius: rem(24px);
    background-color: #ffffff;
    .audioTitle {
        font-size: 12px;
        padding: rem(12px) rem(16px);
        text-align: left;
        font-weight: bolder;
        color: #B12209;
        &::before {
            content: '听-';
        }
    }
}
.audioCtrl {
    display: flex;
    justify-content: space-between;
    padding: 0 rem(16px);
}
.bar {
    width: 100%;
    max-width: 420px;
    height: rem(34px);
    padding: 0 rem(12px);
    line-height:  rem(34px);
    margin-top: rem(4px);
    .progressbar {
        width: 100%;
        height: rem(4px);
        background-color: #999999;
        margin-top: rem(12px);
        border-radius: rem(34px);
        position: relative;
    }

    .greenbar {
        width: 0%;
        height: rem(4px);
        border-radius: rem(34px);
        position: absolute;
        top: 0;
        left: 0;
        background-color: #B12209;
        .yuan {
            display: inline-block;
            // width: 4px;
            // height: 4px;
            padding: 4px;
            // box-shadow: inset 0 0 4px 4px #875599;
            background-color: #B12209;
            border-radius: 50%;
            position: absolute;
            top: -2px;
            right: -6px;
        }
    }
}

.playTime {
    display: flex;
    justify-content: space-between;
}
.time-text {
    display: inline-block;
    // width: 50%;
    // padding: 0 rem(30px);
    font-size: rem(10px);
    box-sizing: border-box;
    &:first-child {
        margin-left: rem(-2px)
    }
}

.right-time {
    text-align: right;
}

.audio-btn {
    // width: 100%;
    text-align: center;
}

.audioBtn {
    display: block;
    width: rem(34px);
    height: rem(34px);
    background-size: cover;
    // margin-right: rem(24px);
}
.playBtn {
    background-image: url('../assets/imgs/play.png');
}
.pauseBtn {
    background-image: url('../assets/imgs/pause.png');
}
.voiceBtn {
    background-image: url('../assets/imgs/voice_open.png');
}
.muteBtn {
    background-image: url('../assets/imgs/voice_close.png');
}
@media screen and (max-height: 568px) {
    .audioPlayer {
        padding-bottom: rem(12px)
    }
}
</style>
